var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_172",
    "data-name": "Group 172",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M19.229,36.62",
    transform: "translate(-9.248 -16.62)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M49.392,50.388c-.4.41-.764.82-1.164,1.2-2.064,1.952-4.123,3.909-6.217,5.832a2.731,2.731,0,0,1-1.239.616,1.049,1.049,0,0,1-1.139-.607,1.1,1.1,0,0,1,.1-1.291,7.939,7.939,0,0,1,.737-.755q3.457-3.21,6.92-6.415c.072-.067.134-.143.229-.246-.157-.165-.3-.328-.45-.474q-3.394-3.2-6.79-6.4a6.93,6.93,0,0,1-.563-.574,1.149,1.149,0,0,1,.069-1.677,1.279,1.279,0,0,1,1.775.03c1.244,1.133,2.459,2.293,3.684,3.444,1.249,1.175,2.509,2.34,3.734,3.537.334.326.516.277.822-.014q3.529-3.35,7.085-6.675a3.607,3.607,0,0,1,.6-.467,1.242,1.242,0,0,1,1.514.189,1.1,1.1,0,0,1,.172,1.437,4.573,4.573,0,0,1-.568.633q-3.546,3.368-7.1,6.731c-.083.079-.15.173-.321.373,1.414,1.294,2.83,2.58,4.235,3.876,1.113,1.026,2.221,2.057,3.31,3.1a2.259,2.259,0,0,1,.59.838.987.987,0,0,1-.431,1.168,1.213,1.213,0,0,1-1.36.118,5.908,5.908,0,0,1-1.076-.831Q53.215,53.97,49.9,50.833c-.132-.124-.273-.24-.508-.445",
    transform: "translate(-39.471 -39.254)",
    fill: "#03234a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGreen);
export default __webpack_public_path__ + "static/media/closeIconGreen.75b833b14388df0335bf913fbb5b2084.svg";
export { ForwardRef as ReactComponent };